import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ToasterMessages } from 'src/app/shared/constants/constants';

import { UploadfilePopupComponent } from './uploadfile-popup/uploadfile-popup.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent {
  requestForm!: FormGroup;
  formSubmitted: boolean = false;
  isSubmitEnabled = true;
  selectedFile: File[] = [];

  @ViewChild('fileInput', { static: false }) fileInput: ElementRef | undefined;




  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,

    private dialog: MatDialog
  ) {
   

  }

  // isDarkMode(): boolean {
  //   return this.req.isDarkMode();
  // }

  clearClick(): void {
  
    this.formSubmitted = false;
    this.selectedFile = [];
    this.isSubmitEnabled = false;
  }

  numberInput(event: Event, controlName: string): void {
    const inputElement = event.target as HTMLInputElement;
    const numericValue = inputElement.value.replace(/[^0-9.]/g, '');
    inputElement.value = numericValue;
    this.requestForm.get(controlName)?.setValue(numericValue);
  }

  uploadfile(): void {
    if (this.fileInput) {
      (this.fileInput.nativeElement as HTMLInputElement).click();
    }
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    if (event.dataTransfer && event.dataTransfer.files) {
      this.handleFiles(event.dataTransfer.files);
    }
  }

  private handleFiles(fileList: FileList): void {
   
    this.selectedFile = Array.from(fileList);
    console.log("fileList",this.selectedFile)
    this.validateFiles();
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      this.selectedFile = Array.from(input.files);
      this.validateFiles();
    }
  }

  private validateFiles(): void {
    const validExtensions = ['xls', 'xlsx', 'xlsm', 'csv'];
    console.log(typeof this.selectedFile)
    const objeFiles = Object.values(this.selectedFile).filter(
     
      (file) =>{
        console.log("OOOOOO",file.name.split('.')) 
        console.log("file.name.split('.').pop()",file.name.split('.').pop()) 
       return  validExtensions.includes(file.name.split('.').pop()?.toLowerCase() || '') 
      }
    );

    if (objeFiles.length === 0) {
      console.log("AAAAAAAAAAAAAAAAAAAAAAAAAAA")
      this.toastr.warning(ToasterMessages.FileWarning);
    
      this.isSubmitEnabled = true;
    } else {
      console.log("objeFiles", objeFiles)
      this.toastr.success(ToasterMessages.FileInput);
 
      objeFiles.map((file)=>{
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          const base64File = reader.result as string;
          // Store the base64 string in local storage
          // localStorage.setItem('uploadedFile', base64File);
          // localStorage.setItem('uploadedFileName', file.name);
          if(base64File){
            const dialogRef = this.dialog.open(UploadfilePopupComponent, {
              width: '450px',
              height: '435px',
              disableClose: true,
              data: { files: objeFiles}
            });
            dialogRef.afterClosed().subscribe((result) => {
  
              if (result) {
                // this.dataToPass = result;
                console.log(result,'result...........');
  
              }
            });
          }
  
        };

       
      })
      this.isSubmitEnabled = objeFiles.length > 0;
    
    }
  }


  
}

